import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=4f188062&scoped=true&"
import script from "./Material.vue?vue&type=script&lang=js&"
export * from "./Material.vue?vue&type=script&lang=js&"
import style0 from "./Material.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Material.vue?vue&type=style&index=1&id=4f188062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f188062",
  null
  
)

export default component.exports